import { SelectOptionT } from './../../../models/models';
import { ClientTypeE } from "../../../models/enums";
import { ClientT } from "../../../models/models";

/**
 * returns sorted post production companies, production companies and advertising agencies select options
*/

export const groupClientsByType = (clients: ClientT[]): SelectOptionT[][] => {
    let postProductionClients = [];
    let productionClients = [];
    let advertisingAgencyClients = [];
    if (clients) {
        const filteredPostClients = clients.filter((client: ClientT) => +client.ClientType === ClientTypeE['Post/sound production']);
        // NOTE: "active companies only" is already enforced server-side — /api/Clients/UserGet only
        // returns clients whose Status == Enabled (ClientsController.UserGet), and its DTO does not
        // even carry Status. So no Status filter belongs here (filtering on the absent field zeroes
        // the list). Just filter by client type.
        const filteredProdClients = clients.filter((client: ClientT) => +client.ClientType === ClientTypeE['Production company']);
        const filteredAdvAgClients = clients.filter((client: ClientT) => +client.ClientType === ClientTypeE['Advertising Agency']);
        if (filteredPostClients) {
            const mappedCompanies = filteredPostClients.map((client: ClientT) => ({ value: +client.Id, label: client.Name }));
            postProductionClients = mappedCompanies;
        }
        if (filteredProdClients) {
            const mappedCompanies = filteredProdClients.map((client: ClientT) => ({ value: +client.Id, label: client.Name }));
            productionClients = mappedCompanies;
        }
        if (filteredAdvAgClients) {
            const mappedAdvAgencies = filteredAdvAgClients.map((client: ClientT) => ({ value: +client.Id, label: client.Name }));

            advertisingAgencyClients = mappedAdvAgencies;
        }
    }

    return [postProductionClients, productionClients, advertisingAgencyClients];
};